import React, {
  useState,
  useCallback,
  memo,
  useEffect,
  useContext,
} from "react";
import "./Products.css";

// components
import {
  Button,
  Container,
  Box,
  TextField,
  FormControl,
  Select,
  Tabs,
  Tab,
  useMediaQuery,
  useTheme,
  InputLabel,
} from "@mui/material";

// redux
import { connect } from "react-redux";
import setRedirectUrl from "../../redux/actions/redirection/setRedirectUrl";

// Hooks
import useFilters from "./hooks/filters.hook";
import useRubros from "./hooks/rubros.hook";
import useLocal from "./hooks/locals.hook";

import EditProduct from "./widgets/EditProduct";
import CreateProduct from "./widgets/CreateProduct";

import ConfirmDialog from "./components/ConfirmDialog";
import MobileProductsList from "./components/Mobile/MobileProductsList";
import Loading from "../../components/Common/Loading";
import Tabla, { BUTTONS } from "./components/Desktop/Tabla";
import Navbar from "../../components/Navbar";
import AlertDialog from "../../components/Common/Dialog";
import SnackBarUtils from "../../utils/SnackBarUtils";
import AccionesMasivasButtons from "./components/AccionesMasivasButtons";
import { Ordenamiento, ordenamientos } from "./utils/ordenamientos";
import { useLocal as findLocal } from "../AbmLocalPage/hooks/local.hook";
import Footer from "../Home/components/Footer";
import { useMetricas } from "../Home/hooks/metricas.hook";
import usePalabrasProhibidas from "./hooks/palabras.prohibidas.hook";
import {
  ProductosVendedorContext,
  Estado,
  TABS,
} from "./context/productos.vendedor.context";
import useAccionesMasivas from "./hooks/acciones.masivas.hook";
import { RolType } from "../../components/Navbar/Sidebar/SidebarItems";
import { IRubro } from "../AdminProducts/types/producto";
import { ITenant } from "../AbmLocalPage/types";
import { TenantsContext } from "../../context/tenants.context";

const USER_ROLES: any = {
  seller: "Vendedor",
  admin: "Administrador",
};

export const getStatusColor = (p: any) => {
  if (p.aprobado && !p.pausado && !p.vencido) return "success";
  if (p.aprobado && !p.pausado && p.vencido) return "warning";
  return "error";
};

export interface ProductListProps {
  products?: any;
  rubros?: IRubro[];
  isAdmin: boolean;
  total?: number;
  handleResumeProduct: (id: string, tenant: ITenant) => void;
  handleUnPauseProducts: () => void;
  handlePauseProduct: (id: string, tenant: ITenant) => void;
  handlePauseProducts: () => void;
  handleDeleteProduct: (id: string, tenant: ITenant) => void;
  handleDeleteProducts: () => void;
  handleChangeRubro: (idRubro: number, tenant: ITenant) => void;
  handleEditProduct: (id: string, tenant: ITenant) => Promise<void>;
}

const INITIAL_ROWS_PER_PAGE = 10;

const AbmProducts: React.FC = (props: any) => {
  const { userLogged } = props.logged;
  const { idLocal, roles, token } = userLogged;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // PAGINADOR

  const {
    tabsProductos,
    setTabsProductos,
    productos,
    accionesMasivas,
    productosSeleccionados,
    setProductosSeleccionados,
    puedePausarVarios,
    puedeReanudarVarios,
    confirmDialog,
    setConfirmDialog,
    setIdLocal,
    getProductosVendedor,
    handleLeft,
    setSearchFilter,
    setRubroFilter,
    ordenamiento,
    setOrdenamiento,
    estado,
    setEstado,
    setPage,
    setPageSize,
    paginator,
    loading: loadingProductos,
  } = useContext(ProductosVendedorContext);
  const isAdmin = roles.includes(USER_ROLES.admin);
  const {
    loadingProductosMasivos,
    handleDeleteProducts,
    handlePauseProducts,
    handleUnPauseProducts,
    handleChangeRubro,
  } = useAccionesMasivas({
    isAdmin,
    productosSeleccionados,
    setProductosSeleccionados,
    setConfirmDialog,
  });

  const [tmpSearchFilter, setTmpSearchFilter] = useState<string>("");
  const [tmpRubroFilter, setTmpRubroFilter] = useState<string>();

  const {
    retail,
    wholesaler,
    maxPhotos,
    maxPublicaciones,
    esMinorista,
    precioDto,
    ofrecerPremium,
    usaSku,
  } = useLocal(idLocal, token);

  const { rubros, loading: loadingRubros } = useRubros();
  const [modalNewProduct, setModalNewProduct] = useState<boolean>(false);
  const [modalEditProduct, setModalEditProduct] = useState<boolean>(false);
  const [editProduct, setEditProduct] = useState(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [cantOfertasDisp, setCantOfertasDisp] = useState<number>(0);
  const { metricas } = useMetricas(idLocal);
  const { palabrasProhibidas, loading: loadingPalabrasProhibidas } =
    usePalabrasProhibidas();
  const {tenant} = useContext(TenantsContext);

  useEffect(() => {
    setIdLocal(idLocal);
  }, [idLocal]);

  paginator.handleChangePage = (e: any, newPage: number) => {
    setPage(newPage);
    let tabs = [...tabsProductos];
    tabs[estado.key].page = newPage;
    setTabsProductos(tabs);
  };

  paginator.handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setPageSize(parseInt(event.target.value, 10));
    //setPage(0);
    let tabs = [...tabsProductos];
    tabs[estado.key].pageSize = parseInt(event.target.value, 10);
    setTabsProductos(tabs);
  };

  const handleActionClick = useCallback(
    async (action: any, id: any) => {
      setLoading(true);
      await BUTTONS[action].action(id, tenant);
      // setProducts((products: any) => products.filter((p: any) => p.id !== id))
      TABS.map((tab: Estado) => {
        getProductosVendedor(tab.key);
      });
      setLoading(false);
    },
    [getProductosVendedor]
  );

  const handleEditProduct = async (id: any) => {
    setEditProduct(id);
    setModalEditProduct(true);
  };

  const executeSearch = async () => {
    setLoading(true);
    setSearchFilter(tmpSearchFilter);
    tmpRubroFilter && setRubroFilter(parseInt(tmpRubroFilter));
    setPage(0);

    setLoading(false);
  };

  const clearConfirmDialog = () => {
    setConfirmDialog((confirmDialog: any) => ({
      ...confirmDialog,
      open: false,
    }));
  };

  const handlePauseProduct = useCallback(
    (productId: any) => {
      setConfirmDialog({
        open: true,
        text: {
          title: "¿Deseas pausar esta publicacion?",
          body: "",
          leftButton: "Cancelar",
          rightButton: "Confirmar",
          colorButtonConfirm: "primary",
        },
        action: async () => {
          setLoading(true);
          await handleActionClick("pause", productId);
          clearConfirmDialog();
          setLoading(false);
        },
        close: () => clearConfirmDialog(),
      });
    },
    [handleActionClick]
  );

  const handleResumeProduct = useCallback(
    (productId: any) => {
      setConfirmDialog({
        open: true,
        text: {
          title: "¿Deseas reanudar esta publicacion?",
          body: "",
          leftButton: "Cancelar",
          rightButton: "Confirmar",
          colorButtonConfirm: "primary",
        },
        action: async () => {
          setLoading(true);
          await handleActionClick("resume", productId);
          clearConfirmDialog();
          setLoading(false);
        },
        close: () => clearConfirmDialog(),
      });
    },
    [handleActionClick]
  );

  const handleDeleteProduct = useCallback(
    (productId: any) => {
      setConfirmDialog({
        open: true,
        text: {
          title: "¿Deseás eliminar esta publicación?",
          body: "Tené en cuenta que esto no se puede deshacer",
          leftButton: "Cancelar",
          rightButton: "Confirmar",
          colorButtonConfirm: "error",
        },
        action: async () => {
          await handleActionClick("delete", productId);
          clearConfirmDialog();
        },
        close: () => clearConfirmDialog(),
      });
    },
    [handleActionClick]
  );

  useEffect(() => {
    metricas && setCantOfertasDisp(metricas.cantOfertasDisp);
  }, [metricas]);

  if (loadingRubros || rubros.length <= 0) return <></>;

  return (
    <>
      <Navbar title="Catálogo de productos" />
      <Container>
        <Box style={{ display: "flex", flexDirection: "column" }}>
          <Box
            style={{
              marginTop: "2vh",
              display: "flex",
              justifyContent: "center",
              gap: isMobile ? "14px" : "10px",
            }}
            sx={{ "@media (max-width:600px)": { flexDirection: "column" } }}
          >
            <FormControl style={{ flexGrow: "1" }}>
              <InputLabel id="demo-simple-select-label">Orden</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                native
                label="Orden"
                value={ordenamiento}
                onChange={(e: any) => setOrdenamiento(e.target.value)}
              >
                {ordenamientos.map((ordenamiento: Ordenamiento) => (
                  <option key={ordenamiento.id} value={ordenamiento.id}>
                    {ordenamiento.criterio}
                  </option>
                ))}
              </Select>
            </FormControl>
            <TextField
              id="outlined-basic"
              style={{ flexGrow: "2" }}
              label="Buscar por nombre, descripción o código/sku"
              onChange={(e: any) => setTmpSearchFilter(e.target.value)}
              onKeyPress={(e: any) => e.key === "Enter" && executeSearch()}
              variant="outlined"
            />
            <FormControl style={{ flexGrow: "1" }}>
              <InputLabel id="demo-simple-select-label">Rubro</InputLabel>
              <Select
                native
                label="Rubro"
                defaultValue={"0"}
                onKeyPress={(e: any) => e.key === "Enter" && executeSearch()}
                onChange={(e: any) => setTmpRubroFilter(e.target.value)}
              >
                <option value="0" label="Todos" />
                {rubros &&
                  rubros?.map((group: any, i: number) => (
                    <optgroup key={i} label={group.nombre.toUpperCase()}>
                      {group?.rubros?.map((subrubro: any, h: number) => {
                        return subrubro.rubros?.length > 0 ? (
                          subrubro.rubros.map((subrubro2: any, j: number) => (
                            <option key={j} value={subrubro2.idrubro}>
                              {subrubro.nombre + " - " + subrubro2.nombre}
                            </option>
                          ))
                        ) : (
                          <option key={h} value={subrubro.idrubro}>
                            {subrubro.nombre}
                          </option>
                        );
                      })}
                    </optgroup>
                  ))}
              </Select>
            </FormControl>

            <Button variant="contained" onClick={() => executeSearch()}>
              Buscar
            </Button>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              flexDirection: isMobile ? "column" : "row-reverse",
              marginY: "20px",
              gap: "20px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                width: isMobile ? "100%" : "100%",
              }}
            >
              <Button
                variant="contained"
                disabled={loading || loadingPalabrasProhibidas}
                fullWidth={isMobile}
                color="success"
                onClick={() => {
                  if (cantOfertasDisp <= 0 && !ofrecerPremium) {
                    SnackBarUtils.info(
                      `Alcanzaste el límite de ${maxPublicaciones} publicaciones`
                    );
                  } else {
                    setModalNewProduct(true);
                  }
                }}
              >
                Agregar nuevo producto
              </Button>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: isMobile ? "center" : "flex-start",
                width: "100%",
              }}
            >
              <Tabs
                value={estado.key}
                scrollButtons="auto"
                variant="scrollable"
              >
                <Tab
                  onClick={() => setEstado(TABS[0])}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        flexDirection: isMobile ? "column" : "row",
                      }}
                    >
                      <span>Activos</span>
                      <span>{`(${tabsProductos[0].totalRecord})`}</span>
                    </Box>
                  }
                />
                <Tab
                  onClick={() => setEstado(TABS[1])}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        flexDirection: isMobile ? "column" : "row",
                      }}
                    >
                      <span>Vencidos</span>
                      <span>{`(${tabsProductos[1].totalRecord})`}</span>
                    </Box>
                  }
                />
                <Tab
                  onClick={() => setEstado(TABS[2])}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        flexDirection: isMobile ? "column" : "row",
                      }}
                    >
                      <span>Inactivos</span>
                      <span>{`(${tabsProductos[2].totalRecord})`}</span>
                    </Box>
                  }
                />
              </Tabs>
            </Box>
          </Box>
        </Box>

        {loadingProductos ? (
          <Loading />
        ) : isMobile ? (
          <MobileProductsList
            loading={loading}
            products={tabsProductos[estado.key].productos}
            total={tabsProductos[estado.key].totalRecord}
            isAdmin={isAdmin}
            handleResumeProduct={handleResumeProduct}
            handlePauseProduct={handlePauseProduct}
            handleDeleteProduct={handleDeleteProduct}
            handleDeleteProducts={handleDeleteProducts}
            handlePauseProducts={handlePauseProducts}
            handleUnPauseProducts={handleUnPauseProducts}
            handleChangeRubro={handleChangeRubro}
            handleEditProduct={handleEditProduct}
            page={tabsProductos[estado.key].page}
            paginator={paginator}
            rowsPerPage={tabsProductos[estado.key].pageSize}
            rubros={rubros}
          />
        ) : (
          <Tabla
            products={tabsProductos[estado.key].productos}
            total={tabsProductos[estado.key].totalRecord}
            isAdmin={isAdmin}
            handleResumeProduct={handleResumeProduct}
            handlePauseProduct={handlePauseProduct}
            handleDeleteProduct={handleDeleteProduct}
            handleDeleteProducts={handleDeleteProducts}
            handlePauseProducts={handlePauseProducts}
            handleUnPauseProducts={handleUnPauseProducts}
            handleChangeRubro={handleChangeRubro}
            handleEditProduct={handleEditProduct}
            loading={loading}
            page={tabsProductos[estado.key].page}
            paginator={paginator}
            rowsPerPage={tabsProductos[estado.key].pageSize}
            isMobile={isMobile}
            usaSku={usaSku}
            rubros={rubros}
          />
        )}
      </Container>

      <div
        style={{
          position:
            tabsProductos[estado.key].totalRecord < 2 || loadingProductos
              ? "fixed"
              : "relative",
          width: "100%",
          bottom: 0,
        }}
      >
        <Footer />
      </div>

      <CreateProduct
        admin={isAdmin}
        open={modalNewProduct}
        setOpen={setModalNewProduct}
        precioDto={precioDto}
        retailer={retail}
        //wholesaler={wholesaler}
        rubros={rubros}
        maxPhotos={maxPhotos}
        idLocal={idLocal}
        getProducts={getProductosVendedor}
        esMinorista={esMinorista}
        cantOfertasDisp={cantOfertasDisp}
        cantProducts={productos.length}
        usaSku={usaSku}
        ofrecerPremium={ofrecerPremium}
        palabrasProhibidas={palabrasProhibidas}
      />

      {editProduct && (
        <EditProduct
          admin={false}
          open={modalEditProduct}
          setOpen={setModalEditProduct}
          precioDto={precioDto}
          retailer={retail}
          idLocal={idLocal}
          editProductId={editProduct}
          getProducts={getProductosVendedor}
          maxPhotos={maxPhotos}
          esMinorista={esMinorista}
          handlePauseProduct={handlePauseProduct}
          usaSku={usaSku}
          ofrecerPremium={ofrecerPremium}
          palabrasProhibidas={palabrasProhibidas}
        />
      )}

      {accionesMasivas && isMobile && (
        <AccionesMasivasButtons
          isAdmin={isAdmin}
          rubros={rubros}
          handleDeleteProducts={handleDeleteProducts}
          handlePauseProducts={handlePauseProducts}
          handleUnPauseProducts={handleUnPauseProducts}
          handleChangeRubro={handleChangeRubro}
          handleLeft={handleLeft}
          puedePausarVarios={puedePausarVarios}
          puedeReanudarVarios={puedeReanudarVarios}
        />
      )}
      <ConfirmDialog {...confirmDialog} disabled={loadingProductosMasivos} />
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    logged: state.logged,
    theme: state.theme,
    toaster: state.toaster,
    redirection: state.redirection,
  };
};

const mapDispatchToProps = {
  // resetToaster,
  setRedirectUrl,
};

export default connect(mapStateToProps, mapDispatchToProps)(memo(AbmProducts));
